export default __webpack_public_path__ + "static/media/UpArrow.a3c1f189.svg";